import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import { getToken } from '@/utils/storage';
import store from '@/store';
const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/reg',
    name: 'reg',
    component: () => import(/* webpackChunkName: "register" */ '../views/register')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login')
  },
  {
    path: '/deposit',
    name: 'deposit',
    component: () => import(/* webpackChunkName: "about" */ '../views/deposit')
  },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/components/home'),
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import(/* webpackChunkName: "home" */ '../views/home')
      },
      {
        path: 'question',
        name: 'question',
        component: () => import(/* webpackChunkName: "lib" */ '../views/home/detail.vue')
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "about" */ '../views/profile')
      },
      {
        path: '/lib',
        name: 'lib',
        component: () => import(/* webpackChunkName: "about" */ '../views/exam-lib')
      }
    ]
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  } else {
    getToken() && store.dispatch('GetAccountInfo');
    next();
  }
});

export default router;
